import React, { Fragment, useContext, useEffect, useState } from "react";
import ReactJson from "react-json-view";
import {
  SelectField,
  RadioField,
  LabelField,
  RichTextField,
  SelectField2,
  InputField2,
  FileField2,
  FileField,
  DownloadField,
  PhoneField,
  StyledDate,
  NumberField,
  InputField,
  ServerPropField,
} from "./FormElements";
import { Formik, Form as FormikForm, Field, useFormikContext } from "formik";
import { update } from "draft-js/lib/DefaultDraftBlockRenderMap";
import PrintPreview from "./PrintPreview";
import { Dialog, Menu, Transition } from "@headlessui/react";
import styled, { useTheme } from "styled-components";
import appFetch from "../appFetch";
import apiEndpoints from "../apiEndpoints";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Spinner from "../loaders/Spinner";
import ImagePlaceholder from "../assets/images/image-placeholder.svg";
import classNames from "classnames";
import AppContext from "../contexts/AppContext";
import useMenuUpdate from "../hooks/useMenuUpdate";
import TransformValue from "./TransformValue";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";
import { mapValidationSchema } from "../formValidation";
import * as Yup from "yup";
import { defaults } from "../mapInitialValues";
import OtpControl from "./OtpControl";
import { saveAs } from "file-saver";
import moment from "moment";
import { mapOperator } from "../util";
import { formatNumber } from "../util/formatter";
import { appendQueryToUri, groupBy, isValidValue } from "../util/generalUtil";
import ConfirmButton from "./ConfirmButton";
import DrillModalDialog from "./DrillModalDialog";
import PrintButton from "./PrintButton";
import WithLoader from "./WithLoader";
import WithOverlay from "./WithOverlay";

let timeout = {};
let formikStatus = {};

const MySwal = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton:
        "text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 bg-primary",
      cancelButton:
        "text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 bg-primary",
    },
    buttonsStyling: false,
  })
);

function mapField(type) {
  switch (type) {
    case "select":
    case "multiselect":
      return SelectField;
    case "radio":
      return RadioField;
    case "dropdown":
      return SelectField;
    case "label":
      return LabelField;
    case "richtext":
      return RichTextField;
    case "phonenumber":
      return PhoneField;
    case "date":
    case "datetime":
      return StyledDate;
    case "number":
      return NumberField;
    case "upload":
      return FileField2;
    case "download":
      return DownloadField;
    case "serverprop":
      return ServerPropField;
    default:
      return InputField;
  }
}

const buildEditData = (postData, editData) => {
  console.log("editData", editData, postData);
  let ref = postData;
  let count = 1;
  let curr = `ID_ROOT_${count}`;
  let prop = "";
  console.log("lets see the edit", editData, postData);
  while (true) {
    prop = editData[`ID_ROOT_${count}`];

    //check if next exist
    if (typeof editData[`ID_ROOT_${count + 1}`] == "undefined") break;

    ref[prop] = typeof ref[prop] != "undefined" ? ref[prop] : {};
    ref = ref[prop];

    count++;
  }

  ref[prop] = editData[prop];
  return postData;
};

const CommentModal = ({ isOpen, setIsOpen, buttonData, updateData }) => {
  let { data, targetid, buttonAction, buttonName } = buttonData;
  const [processing, setProcessing] = useState(false);
  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen h-full">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <div className="relative bg-white mx-auto my-10 rounded-md">
          <div className="p-6 pt-14">
            <button
              className="absolute right-4 top-4"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9651 10.4985L20.4829 2.99719C20.8121 2.66793 20.997 2.22136 20.997 1.75571C20.997 1.29007 20.8121 0.843497 20.4829 0.514237C20.1536 0.184977 19.7071 0 19.2416 0C18.776 0 18.3295 0.184977 18.0003 0.514237L10.5 8.03304L2.99975 0.514237C2.67053 0.184977 2.22403 -3.46932e-09 1.75845 0C1.29287 3.46932e-09 0.846361 0.184977 0.517147 0.514237C0.187934 0.843497 0.00298367 1.29007 0.00298367 1.75571C0.00298366 2.22136 0.187934 2.66793 0.517147 2.99719L8.03488 10.4985L0.517147 17.9998C0.353281 18.1624 0.223217 18.3558 0.134458 18.5688C0.0456982 18.7819 0 19.0105 0 19.2413C0 19.4721 0.0456982 19.7007 0.134458 19.9138C0.223217 20.1268 0.353281 20.3202 0.517147 20.4828C0.679675 20.6467 0.87304 20.7768 1.08609 20.8655C1.29914 20.9543 1.52765 21 1.75845 21C1.98925 21 2.21776 20.9543 2.43081 20.8655C2.64386 20.7768 2.83722 20.6467 2.99975 20.4828L10.5 12.964L18.0003 20.4828C18.1628 20.6467 18.3561 20.7768 18.5692 20.8655C18.7822 20.9543 19.0108 21 19.2416 21C19.4723 21 19.7009 20.9543 19.9139 20.8655C20.127 20.7768 20.3203 20.6467 20.4829 20.4828C20.6467 20.3202 20.7768 20.1268 20.8655 19.9138C20.9543 19.7007 21 19.4721 21 19.2413C21 19.0105 20.9543 18.7819 20.8655 18.5688C20.7768 18.3558 20.6467 18.1624 20.4829 17.9998L12.9651 10.4985Z"
                  fill="#747474"
                />
              </svg>
            </button>
            <div className="">
              <Formik
                initialValues={{ APPROVAL_MEMO: "" }}
                onSubmit={async (values, { resetForm }) => {
                  let newData = { ...data };
                  newData["_HEADER"] = { ...newData["_HEADER"], ...values };
                  setProcessing(true);
                  await updateData({ data: newData, targetid, buttonAction });
                  setProcessing(false);
                  setIsOpen(false);
                }}
              >
                <FormikForm className="grid">
                  <Field
                    as="textarea"
                    rows={6}
                    cols={50}
                    name="APPROVAL_MEMO"
                    autoComplete="off"
                    placeholder="add comment"
                    className="pl-3 placeholder-custom-gray-100 placeholder-opacity-40 appearance-none relative block w-full px-3 py-2 border border-custom-gray-300 text-gray-500 rounded-md focus:outline-none sm:text-sm"
                  />
                  <button className="mt-3 bg-primary text-white py-2 rounded-md inline-block self-end inline-flex justify-center">
                    {processing ? (
                      <Spinner width={20} height={20} fill="#f7f7f7" />
                    ) : (
                      buttonName
                    )}
                  </button>
                </FormikForm>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const BidModal = ({
  isOpen,
  setIsOpen,
  bidOptions,
  setBidOptions,
  actions,
  getInitialValues,
  getObjectValue,
}) => {
  const updateButton = {
    name: "Update",
    value: "Update",
    action: "modal",
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      className="flex items-center justify-center fixed z-10 inset-0 overflow-y-auto"
    >
      <div className="mx-auto" style={{ width: "80%" }}>
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <div className="relative bg-white mx-auto my-10">
          <div className="p-2">
            <div className="mb-2 flex justify-end">
              <button
                type="button"
                className="pointer inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md"
                onClick={() => {
                  setIsOpen(false);
                  setBidOptions(null);
                }}
              >
                Close
              </button>
            </div>

            <EditableTableRow
              item={{ ...bidOptions, button: [bidOptions.buttonItem] }}
              getInitialValues={getInitialValues}
              getObjectValue={getObjectValue}
              actions={actions}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const OtpModal = ({
  isOpen,
  otpPhone,
  closeModal,
  sendOtp,
  otherProps,
  actions,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <OtpControl
                  closeModal={closeModal}
                  otpPhone={otpPhone}
                  sendOtp={sendOtp}
                  otherProps={otherProps}
                  actions={actions}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

const ButtonStyle = styled.button`
  background: #f5f5f5;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
`;

const ButtonStyle3 = styled.button`
  background: #f5f5f5;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
`;

const ButtonStyle2 = styled.button`
  color: #5d5d5d;
`;

const sendOtp = (props) =>
  new Promise((resolve, reject) => {
    const { menuId, value: buttonAction, headerControl, ...rest } = props;

    let jsonData = {};

    headerControl.forEach((o) => {
      jsonData = buildEditData(jsonData, o);
    });

    let postData = {
      jsonString: JSON.stringify(jsonData),
      menuId: props.menuId,
      pageButtonActionId: null,
      buttonAction: buttonAction,
    };

    appFetch
      .post(apiEndpoints.sendOtp, {
        body: JSON.stringify(postData),
      })
      .then((result) => {
        console.log("result from otp sent", result);
        let { ERROR_MESSAGE: errMsg, ERROR_NUMBER: errNo } = result;

        if (errNo !== 0) {
          MySwal.fire({
            text: errMsg,
            icon: "error",
          });
          throw new Error(errMsg);
        }

        resolve(result);
      })
      .finally(() => resolve(true));
  });

const fetchModalDetails = (props) =>
  new Promise((resolve, reject) => {
    const { menuId, value: buttonAction, headerControl, ...rest } = props;

    let jsonData = {};

    headerControl.forEach((o) => {
      jsonData = buildEditData(jsonData, o);
    });

    console.log("the value of props here", props, buttonAction);

    let postData = {
      layoutId: props.layout_id,
      drillId: props.drill_id,
      target: props.action_type?.toUpperCase(),
      targetType: props.action_type?.toUpperCase(),
      targetName: buttonAction,
    };

    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, postData))
      .then((result) => {
        console.log("value of payroll variance", result);
        // let { ERROR_MESSAGE: errMsg, ERROR_NUMBER: errNo } = result;

        // if (errNo !== 0) {
        //   MySwal.fire({
        //     text: errMsg,
        //     icon: "error",
        //   });
        //   throw new Error(errMsg);
        // }

        resolve(result);
      })
      .finally(() => resolve(true));
  });

const TransactionLineButton = WithOverlay((props) => {
  let {
    button_otp,
    values,
    submitForm,
    targetid,
    layoutid,
    target,
    editable_controls,
    headerControl,
    lines,
    value,
    name,
    actions,
    item,
    validateForm,
    setErrors,
    setTouched,
    setOverlay,
  } = props;

  const [processing, setProcessing] = useState(false);
  const [otpModal, showOtpModal] = useState(false);
  const [btnDetailsModal, showBtnDetailsModal] = useState(false);
  const [btnDetailsModalData, setBtnDetailsModalData] = useState(null);
  const { context } = useContext(AppContext);
  const [otpPhone, setOtpPhone] = useState(null);
  const { menuId } = context;

  const buttonClick = async () => {
    setProcessing(true);
    setOverlay(true);
    console.log("transaction button props", { menuId, ...props });

    if (props.button_otp?.toLowerCase() === "yes") {
      let response = await sendOtp({ menuId, ...props });
      setProcessing(false);
      if (response) {
        setOtpPhone(response.userPhoneNumber);
        setTimeout(() => showOtpModal(true), 300);
      }

      setProcessing(false);
      setOverlay(false);
      return;
    }

    if (props.action_type?.toLowerCase() === "modal") {
      let response = await fetchModalDetails({ menuId, ...props });
      console.log("response from fetchModalDetails", response);
      setProcessing(false);
      setBtnDetailsModalData(response);
      setTimeout(() => showBtnDetailsModal(true), 300);

      setProcessing(false);
      setOverlay(false);
      return;
    }

    await actions({
      name,
      values,
      submitForm,
      targetid,
      layoutid,
      target,
      controls: editable_controls,
      headerControl,
      lines,
      value,
      item,
      validateForm,
      setErrors,
      setTouched,
    });
    setProcessing(false);
    setOverlay(false);
  };

  //   <PrintPreview data={item} menuId={menuId} />;
  return (
    <>
      {otpModal && (
        <OtpModal
          isOpen={otpModal}
          otpPhone={otpPhone}
          otherProps={{ ...props, menuId }}
          actions={actions}
          sendOtp={sendOtp}
          closeModal={() => showOtpModal(false)}
        />
      )}
      {btnDetailsModal && (
        <DrillModalDialog
          isOpen={btnDetailsModal}
          closeModal={() => showBtnDetailsModal(false)}
          item={btnDetailsModalData}
        />
      )}
      {["approve", "reject", "delete", "update", "memo"].includes(
        name?.toLowerCase()
      ) ? (
        <ButtonStyle
          as={ConfirmButton}
          action={name?.toLowerCase()}
          className="shadow-md bg-gray-100 p-2 px-3 rounded-md text-xs font-semibold inline-flex justify-center self-start"
          disabled={processing}
          onClick={buttonClick}
        >
          {processing ? (
            <Spinner width={16} height={16} fill="#aaaaaa" />
          ) : (
            name
          )}
        </ButtonStyle>
      ) : (
        // <ButtonStyle
        //   //   as={PrintPreview}
        //   //   data={props}
        //   className="shadow-md bg-gray-100 p-2 px-3 rounded-md text-xs font-semibold inline-flex justify-center self-start"
        //   disabled={processing}
        //   onClick={buttonClick}
        // >
        //   {processing ? (
        //     <Spinner width={16} height={16} fill="#aaaaaa" />
        //   ) : (
        //     name
        //   )}
        // </ButtonStyle>

        <button
          type="button"
          className="pointer inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md"
          disabled={processing}
          onClick={buttonClick}
        >
          {processing ? (
            <Spinner width={16} height={16} fill="#aaaaaa" />
          ) : (
            name
          )}
        </button>
      )}
    </>
  );
});

const FormWithContext = ({
  props,
  otherProps,
  header,
  lines,
  hasDownload,
  hasUpload,
  _controls,
  editable_controls,
  button,
  collapseSection,
  hasInnerOptions,
  setActiveItem,
  setChildOptions,
  layoutid,
  target,
  targetid,
}) => {
  const {
    values,
    handleChange,
    setFieldValue,
    setValues,
    setStatus,
    status,
    validateForm,
    setErrors,
    setTouched,
    submitForm,
  } = props;
  const theme = useTheme();
  let computeEvents = {};

  console.log("FormikContext", {
    props,
    otherProps,
    header,
    lines,
    hasDownload,
    hasUpload,
    _controls,
    editable_controls,
    button,
    collapseSection,
    hasInnerOptions,
    setActiveItem,
    setChildOptions,
  });

  const appContext = useContext(AppContext);
  console.log("the formcontext _control", _controls, lines);

  for (let control of _controls) {
    let {
      validation,
      type,
      name,
      compute,
      options,
      server_fields,
      script,
      script_field,
      serverControl,
    } = control;

    console.log("the formcontext control", control);

    if (script_field) {
      lines.forEach((m, idx) => {
        let _name = `${name}_line_${m["LINE"]}`;
        computeEvents[_name] = [];
        let func = (() => {
          options = options || [];
          let scriptOptions = [...options];
          let defaultScript = script;

          return (e) => {
            let { value: fieldValue, name: fieldName } = e.target;
            let line = fieldName.match(/_line.+/)[0];
            console.log("script_field", e.target);
            let scriptProps =
              {}.constructor == fieldValue?.constructor
                ? fieldValue
                : scriptOptions.find((m) => m.value === fieldValue);

            if (defaultScript) {
              scriptProps = scriptProps || { script: defaultScript };
            }

            console.log("scriptProps", scriptProps);
            if (!scriptProps) return;

            let scriptArr = scriptProps.script;

            let newStatus = {};

            scriptArr.forEach((sc) => {
              let { field, ...rest } = sc;
              newStatus[`${field}${line}`] = rest;
            });

            console.log("newStatus", newStatus);

            let statusMod = { ...(status || {}), ...newStatus };

            if (Object.keys(statusMod).length > 0) {
              formikStatus = { ...statusMod };
              setStatus(statusMod);
            }
          };
        })();
        computeEvents[_name].onChange = (
          computeEvents[_name]?.onChange ?? []
        ).concat(func);
      });
    }

    if (type === "serverprop" && server_fields) {
      lines.forEach((m, idx) => {
        let _name = `${name}_line_${m["LINE"]}`;
        let _server_fields = [...server_fields].map(
          (n) => `${n}_line_${m["LINE"]}`
        );

        console.log("_server_fields", _server_fields);

        for (let field of _server_fields) {
          let func = (() => {
            let fields = _server_fields;
            let serverControl = { ...control };

            return (e) => {
              let { value: fieldValue, name: fieldName } = e.target;

              let currVals = {};

              fieldValue = moment.isDate(fieldValue)
                ? moment(fieldValue).format("YYYY-MM-DD")
                : fieldValue;

              currVals[fieldName.replace(/_line_\d/, "")] =
                fieldValue?.value ?? fieldValue;
              fields.forEach((f) => {
                if (f === fieldName) return;
                let value = values[f];
                value = moment.isDate(value)
                  ? moment(value).format("YYYY-MM-DD")
                  : value;
                currVals[f.replace(/_line_\d/, "")] = value?.value ?? value;
              });

              if (Object.values(currVals ?? {}).some((x) => !isValidValue(x))) {
                return;
              }

              console.log("e.target", e.target);

              let handler = () => {
                console.log("e.target", "calling handler with name", _name);
                setFieldValue(_name, "loading...");
                let payload = {
                  jsonString: JSON.stringify([currVals]),
                  targetId: serverControl?.target_id?.toString(),
                  target: type,
                  applicationId: appContext?.menuId?.toString,
                  parentDropValue: null,
                };

                appFetch
                  .post(apiEndpoints.getServerProps, {
                    body: JSON.stringify(payload),
                  })
                  .then((res) => {
                    console.log("response is", res);
                    setFieldValue(_name, res);
                  })
                  .catch((e) => console.log(e.message))
                  .finally();
              };

              //debounce here
              console.log("timeout", timeout);
              if (timeout[e.name]) {
                clearTimeout(timeout);
              }
              timeout[e.name] = setTimeout(handler, 500);
            };
          })();

          if (!computeEvents[field]) {
            computeEvents[field] = {};
          }

          computeEvents[field].onChange = (
            computeEvents[field]?.onChange ?? []
          ).concat(func);
        }

        console.log("compute fields", computeEvents);
      });
    }

    if (compute instanceof Object) {
      let { operator, withField } = compute;
      let reduceFunc = mapOperator(operator);

      console.log("the lines are", lines);
      lines.forEach((m, idx) => {
        let withFields = withField.map((n) => `${n}_line_${m["LINE"]}`);
        console.log("the line are withFields", withFields);

        for (let field of withFields) {
          let func = (() => {
            let _name = `${name}_line_${m["LINE"]}`;
            let fields = [...withFields];
            return (e) => {
              let { value: fieldValue, name: fieldName } = e.target;
              let currVals = {};
              currVals[fieldName] = fieldValue;

              let computeValues = fields.map((f) => {
                if (f === fieldName) {
                  return parseFloat(fieldValue?.replace(/\,/g, ""));
                }
                return parseFloat(values[f]?.toString()?.replace(/\,/g, ""));
              });

              let result = computeValues.reduce(reduceFunc);
              setFieldValue(_name, formatNumber(result) || "");
            };
          })();

          if (!computeEvents[field]) {
            computeEvents[field] = {};
          }

          computeEvents[field].onChange = (
            computeEvents[field]?.onChange ?? []
          ).concat(func);
        }
      });
      control.disabled = true;
    }
  }

  const [checkedLines, setCheckedLines] = useState(
    new Array(lines.length).fill(false)
  );
  const [lastCheckIndex, setLastCheckIndex] = useState(null);

  const toggleCheck = ({ nativeEvent: { shiftKey: shiftKeyDown } }, lineNo) => {
    const newState = [...checkedLines];
    const lineChecked = newState[lineNo];

    const direction = lastCheckIndex < lineNo ? 1 : -1;
    const diff = Math.abs(lastCheckIndex - lineNo);
    let movement = lastCheckIndex;

    if (shiftKeyDown) {
      for (var i = 0; i <= diff; i++) {
        newState[movement] = !lineChecked;
        movement += direction;
      }
    } else {
      newState[lineNo] = !newState[lineNo];
    }

    setCheckedLines((prev) => newState);
    setLastCheckIndex(lineNo);
  };

  const publishInputChange = (fieldName, newValue) => {
    let newFieldName = fieldName.replace(/_line_\d+/, "");
    let newFields = {};

    let lineNo = fieldName.match(/\d+/)[0] ?? 0;
    if (checkedLines[lineNo - 1]) {
      checkedLines.forEach((isChecked, lineIdx) => {
        if (isChecked) {
          let field = `${newFieldName}_line_${lineIdx + 1}`;
          newFields[field] = newValue;
        }
      });
      setValues({ ...values, ...newFields });
    } else {
      newFields[fieldName] = newValue;
      setValues({ ...values, ...newFields });
    }
  };

  console.log("computeEvents", computeEvents);
  console.log("the values are", values);

  return (
    <>
      <div className="overflow-x-visible w-full tranx-table scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-300">
        <table className="min-w-full leading-normal">
          <thead>
            <tr>
              {header?.map((str, idx) => {
                return (
                  <th
                    key={idx}
                    className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    {str?.replace(/_/g, " ")}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {lines.map((row, rowIdx) => (
              <>
                <tr
                  key={rowIdx}
                  className={classNames("border-gray-300", {
                    "border-b": rowIdx + 1 != lines.length,
                    "bg-gray-100": checkedLines[rowIdx],
                  })}
                >
                  {header?.map((str, tdIndex) => {
                    const editableControl = editable_controls?.find(
                      (c) => c.column === str
                    );
                    let { column, name, parent, ...rest } =
                      editableControl || {};

                    name = `${name}_line_${row["LINE"]}`;
                    if (parent) {
                      parent = `${parent}_line_${row["LINE"]}`;
                    }

                    let value = row[str.toUpperCase()];

                    let events = computeEvents[name] ?? {};
                    //eg: onChange: [] onKeyup: []
                    let eventHandlers = {};
                    Object.keys(events).forEach((eventType) => {
                      //eventType onChange
                      eventHandlers[eventType] = (e) => {
                        //e as target
                        //handleChange(e);
                        events[eventType].forEach((func) => {
                          func(e);
                        });
                      };
                    });

                    console.log("computeEvents2", name, eventHandlers);

                    return (
                      <td className="px-5 py-2 border-gray-200 text-sm">
                        {tdIndex == 0 && (
                          <div className="flex items-center">
                            {(lines?.length ?? 0) > 1 && (
                              <div class="mb-[0.125rem] mr-[0.25rem] block min-h-[1.5rem] pl-[1.5rem]">
                                <input
                                  class="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_var(--primary)] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_var(--primary)]"
                                  type="checkbox"
                                  value=""
                                  onChange={(e) => toggleCheck(e, rowIdx)}
                                  checked={checkedLines[rowIdx]}
                                />
                              </div>
                            )}
                            <p
                              className={classNames(
                                "text-gray-900 whitespace-no-wrap text-xs",
                                {
                                  "text-primary underline":
                                    str.toLowerCase() == "item",
                                }
                              )}
                            >
                              <TransformValue value={value} />
                            </p>
                          </div>
                        )}
                        {tdIndex != 0 && (
                          <>
                            {editableControl ? (
                              <div>
                                {React.createElement(
                                  mapField(editableControl.type),
                                  {
                                    name,
                                    parent,
                                    status,
                                    value,
                                    useVariableWidth: true,
                                    ...eventHandlers,
                                    publishInputChange,
                                    ...rest,
                                  }
                                )}
                              </div>
                            ) : (
                              <p
                                className={classNames(
                                  "text-gray-900 whitespace-no-wrap text-xs",
                                  {
                                    "text-primary underline":
                                      str.toLowerCase() == "item",
                                  }
                                )}
                              >
                                <TransformValue value={value} />
                              </p>
                            )}
                          </>
                        )}
                      </td>
                    );
                  })}
                </tr>
                {hasUpload && row["UPLOAD"] === "Yes" && (
                  <tr>
                    <td colspan={(header?.length || 0) + (hasUpload ? 1 : 0)}>
                      <div className="bg-gray-100 px-6 py-3">
                        <FileField
                          name={`${hasUpload.name}_line_${row["LINE"]}`}
                          label="Upload..."
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>

      <ButtonActions
        {...{
          item: otherProps.item,
          headerControl: otherProps.headerControl,
          lines: otherProps.lines,
          editable_controls,
          setActiveItem,
          setChildOptions,
          actions: otherProps.actions,
          layoutid,
          target,
          targetid,
          button,
          values,
          validateForm,
          setErrors,
          setTouched,
        }}
      />

      {/* <div className="flex gap-2 justify-between mt-3 mb-1 lg:flex-row flex-col">
        <ButtonStyle
            className="shadow-md bg-gray-100 p-2 px-3 rounded-md text-xs font-semibold flex items-center"
            onClick={collapseSection}
            >
            <ToggleGridButtonIcon className="shadow w-4 h-4 rounded-full inline-grid place-items-center">
              <ChevronUpIcon
                width={16}
                height={16}
                fill={theme?.colors?.primary}
              />
            </ToggleGridButtonIcon>
            <span className="ml-2 text-xs font-medium text-black">
              Collapse
            </span>
            </ButtonStyle>
        <div className="flex gap-2 ">
          {console.log(button)}
          {button?.map((item, idx) => (
            <TransactionLineButton
              key={idx}
              validateForm={validateForm}
              setErrors={setErrors}
              setTouched={setTouched}
              {...otherProps}
              {...item}
              {...{editable_controls, values }}
            />
          ))}
        </div>
      </div> */}
    </>
  );
};

const EditableTableRow = ({
  layoutid,
  target,
  targetid,
  button,
  item,
  getInitialValues,
  getObjectValue,
  actions,
  collapseSection,
  setActiveItem,
  action,
  setChildOptions,
}) => {
  let {
    line_header,
    line_data,
    attachment,
    line_control_edit,
    //button,
    edit_header,
    //targetid,
    parent,
    options: innerOptions,
  } = item;

  //   const menuId = context?.menuId;
  const theme = useTheme();
  let lines = line_data ?? [];
  let header = (line_header || [])[0]?.name ?? [];
  let attachments = (attachment || [])[0]?.name ?? [];
  let editable_controls = (line_control_edit || [])[0]?.name ?? [];
  let hasUpload = editable_controls?.find((m) => m.type == "upload");
  let hasDownload = editable_controls?.find((m) => m.type == "download");

  let headerControl = parent ?? edit_header ?? [];
  header = header?.filter((str) => !/attachment/i.test(str));
  editable_controls = editable_controls?.filter(
    (row) => !/attachment/i.test(row?.column)
  );

  //

  let _controls = editable_controls?.filter(
    (row) => !/download/i.test(row?.column)
  );

  //remove non-applicable columns before making initialValues object
  let initialValues = getInitialValues(_controls, lines);
  console.log("the initial value", initialValues, lines);

  let validationSchema = {};

  for (let control of _controls) {
    let { type, value, name, parent, defaultValue, validation } = control;

    if (/label/i.test(type)) {
      continue;
    }

    lines.forEach((m) => {
      let propName = `${name}_line_${m["LINE"]}`;
      console.log("propName", propName);

      if (validation?.lessThanOrEqual) {
        const lessThanOrEqual = `${control.validation.lessThanOrEqual}_line_${m["LINE"]}`;
        validationSchema[propName] = mapValidationSchema({
          ...control,
          name: propName,
          validation: { ...validation, lessThanOrEqual },
        });
        return;
      }

      if (validation?.lessThan) {
        const lessThan = `${control.validation.lessThan}_line_${m["LINE"]}`;
        validationSchema[propName] = mapValidationSchema({
          ...control,
          name: propName,
          validation: { ...validation, lessThan },
        });
        return;
      }

      if (validation?.greaterThanOrEqual) {
        const greaterThanOrEqual = `${control.validation.greaterThanOrEqual}_line_${m["LINE"]}`;
        validationSchema[propName] = mapValidationSchema({
          ...control,
          name: propName,
          validation: { ...validation, greaterThanOrEqual },
        });
        return;
      }

      if (validation?.greaterThan) {
        const greaterThan = `${control.validation.greaterThan}_line_${m["LINE"]}`;
        validationSchema[propName] = mapValidationSchema({
          ...control,
          name: propName,
          validation: { ...validation, greaterThan },
        });
        return;
      }

      validationSchema[propName] = mapValidationSchema({
        ...control,
        name: propName,
      });
    });
  }

  return (
    <Formik
      key={action}
      initialValues={initialValues}
      validationSchema={Yup.object(validationSchema)}
    >
      {(props) => {
        return (
          <>
            <FormikForm>
              <FormWithContext
                props={props}
                header={header}
                lines={lines}
                hasInnerOptions={(innerOptions || []).length > 0}
                hasUpload={hasUpload}
                hasDownload={hasDownload}
                _controls={_controls}
                editable_controls={editable_controls}
                button={button}
                collapseSection={collapseSection}
                otherProps={{ targetid, headerControl, lines, actions, item }}
                setActiveItem={setActiveItem}
                setChildOptions={setChildOptions}
                layoutid={layoutid}
                target={target}
                targetid={targetid}
              />
            </FormikForm>
          </>
        );
      }}
    </Formik>
  );
};

const getInitialValues = (controls, lines) => {
  let values = {};
  lines?.forEach((row) => {
    controls?.forEach(({ name, type }) => {
      let newName = `${name}_line_${row["LINE"]}`;
      values[newName] = row[name?.toUpperCase()] ?? defaults(type);
      values[newName] = ["number", "money"].includes(type)
        ? parseFloat(values[newName])
        : values[newName];
    });
  });
  return values;
};

const getObjectValue = (value) => {
  if (Array.isArray(value))
    return (
      <ul className="flex">
        {value?.map((item, idx) => {
          if (/[\/.](gif|jpg|jpeg|tiff|png)$/i.test(item)) {
            return (
              <li className="mr-0.5">
                <div className="w-8 h-8 bg-gray-100 p-0.5 rounded-md">
                  <img
                    src={item ?? ImagePlaceholder}
                    className="rounded-md w-full h-full obect-center object-cover"
                  />
                </div>
              </li>
            );
          }
          return (
            <li>
              <span key={idx}>
                {idx > 0 && <>&amp;</>}
                {item}
              </span>
            </li>
          );
        })}
      </ul>
    );
  return value;
};

function TransactionListLine({
  data,
  setGroupDrill,
  setGroups,
  hasMultiButton,
}) {
  const [previewData, setPreviewData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [buttonAction, updateButtonAction] = useState(null);
  const [buttonData, updateButtonData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [target, setModalTarget] = useState(null);
  const [bidModal, setBidModal] = useState(false);
  const [bidOptions, setBidOptions] = useState(false);
  const { context, setContext } = useContext(AppContext);
  const menuId = context?.menuId;
  const { updateMenu } = useMenuUpdate();

  const actions = async ({
    submitForm,
    values,
    targetid,
    layoutid,
    target,
    controls,
    headerControl,
    lines,
    name,
    value,
    item,
    validateForm,
    setErrors,
    setTouched,
    codes,
  }) => {
    console.log("testing", {
      submitForm,
      values,
      targetid,
      layoutid,
      target,
      controls,
      headerControl,
      lines,
      name,
      value,
      item,
      validateForm,
      setErrors,
      setTouched,
      codes,
    });

    value = value?.toString()?.toUpperCase();
    name = name.toUpperCase();
    var postData = {};

    console.log("lets see the postData", postData, headerControl);
    console.log("lets see the values", values, value);
    // postData = buildEditData(values);
    // postData = buildData(controls, lines, values);
    headerControl.forEach((o) => {
      postData = buildEditData(postData, o);
    });

    console.log("values", values, controls, name);

    switch (name) {
      case "APPROVE":
      case "MEMO":
      case "REJECT":
        updateButtonData({
          data: postData,
          targetid,
          buttonAction: value,
          buttonName: name,
        });
        setCommentModalOpen(true);
        return;
      case "DOWNLOAD":
        let newData = { ...postData };
        newData["_HEADER"] = { ...newData["_HEADER"], USER_OTP: codes };
        let result = await updateData({
          data: newData,
          targetid,
          buttonAction: value,
          buttonName: name,
        });
        return result;
      case "PRINT":
        var res = await printAction({
          ...item,
          target,
          targetid,
          layoutid,
          action: name,
        });
        return res;
      // default:
      //     return await updateData({data:postData,targetid,buttonAction:value,buttonName:name});
      default:
        //validate form if exists
        try {
          let formSubmission = await validateForm();
          console.log("formSubmission", formSubmission);
          if (Object.keys(formSubmission).length) {
            setTouched(formSubmission);
            return;
          }
        } catch {}

        console.log("value of controls", controls);
        lines?.forEach((row) => {
          var data = {};
          for (let control of controls) {
            let { name, type, response } = control;

            if (/label/i.test(type)) {
              continue;
            }

            let ref = data;
            let count = 1;
            let curr = `root_${count}`;
            let prop = "";
            while (true) {
              prop = control[`root_${count}`];

              //check if next exist
              if (typeof control[`root_${count + 1}`] == "undefined") break;

              ref[prop] = ref[prop] || {};
              ref = ref[prop];

              count++;
            }

            if (!prop) continue;
            let newName = `${name}_line_${row["LINE"]}`;

            console.log("current point", values);
            let formValue = values[newName];

            if (type === "number") {
              formValue = formValue?.toString()?.replace(/,/g, "");
            }

            console.log("what is the formValue before", formValue);
            // if (Array.isArray(formValue)) {
            //   formValue = formValue?.map((m) => m?.value).join("");
            // }
            if (Array.isArray(formValue)) {
              if (formValue.length > 1) {
                // Return an array of values without concatenating into a single string
                formValue = formValue.map((m) => m?.value);
              } else {
                // Wrap the single value in an array
                formValue = formValue[0]?.value ? [formValue[0].value] : [];
              }
            }

            console.log("what is the formValue after", formValue);

            if ({}.constructor === formValue?.constructor) {
              formValue = formValue?.value;
            }

            if (moment.isDate(formValue)) {
              formValue = moment(formValue).format("YYYY-MM-DD h:mmA");
            }

            formValue =
              response === "array"
                ? [].concat(formValue).filter((m) => m) // Ensure it's an array and filter out falsy values
                : formValue;

            console.log("let me check something", formValue, response);
            ref[prop] = formValue;
          }

          let lineProp = Object.keys(data).slice(-1)[0];
          console.log("data from transaction line", data, postData);

          if (lineProp) {
            data[lineProp]["LINE"] = row["LINE"];
            postData[lineProp] = (postData[lineProp] ?? []).concat(
              data[lineProp]
            );
          }
        });
        return await updateData({
          data: postData,
          targetid,
          buttonAction: value,
          buttonName: name,
        });
    }
  };

  console.log("the data is", data);

  const printAction = (data) =>
    new Promise((resolve, reject) => {
      console.log("data of print action", data);

      let postData = {
        action: data.action,
        layoutId: data.layoutid,
        targetId: data.targetid,
        target: data.target,
      };

      console.log("the print preview postdata", postData);
      appFetch
        .get(appendQueryToUri(apiEndpoints.menuView, postData))
        .then((result) => {
          let printData = ((result?.options ?? [])[0]?.line_details ?? [])[0];
          printData ??= (result?.options ?? [])[0];

          if (typeof printData == "undefined") {
            MySwal.fire({
              text: "invalid print data",
              icon: "error",
            });
            resolve(true);
            return;
          }

          setIsOpen(true);
          setPreviewData(printData);

          resolve(result);
        })
        .finally(() => resolve(true));
      // setTimeout(() => {
      //   setIsOpen(true);
      //   setPreviewData(data);
      //   resolve(true);
      // }, 1000);
    });

  //Do not, that @page_button_action_id it is reserved for either pageid or action id
  const updateData = ({ data, targetid, buttonAction }) =>
    new Promise((resolve, reject) => {
      let postData = {
        jsonString: JSON.stringify([data]),
        menuId: menuId,
        pageButtonActionId: null,
        buttonAction: buttonAction,
      };

      console.log("postData =>=>", postData, data);

      try {
        let jsonString =
          '[{"_HEADER":{"PARENT":{"parent_id":195312}},"_LINE_UPDATE":[{"LINE_GENERAL":{"sub_header_number":"1.1.1"},"OTHER_OBJECT":{"scuml_response":["41086"]},"LINE":1},{"LINE_GENERAL":{"sub_header_number":"1.1.2"},"OTHER_OBJECT":{"scuml_response":["41080"]},"LINE":2},{"LINE_GENERAL":{"sub_header_number":"1.1.3"},"OTHER_OBJECT":{"scuml_response":["41083"]},"LINE":3},{"LINE_GENERAL":{"sub_header_number":"1.1.4"},"OTHER_OBJECT":{"scuml_response":["41087"]},"LINE":4},{"LINE_GENERAL":{"sub_header_number":"1.2.1"},"OTHER_OBJECT":{"scuml_response":["41089","41090","41091"]},"LINE":5},{"LINE_GENERAL":{"sub_header_number":"1.2.2"},"OTHER_OBJECT":{"scuml_response":["41095","41096"]},"LINE":6},{"LINE_GENERAL":{"sub_header_number":"1.3.1"},"OTHER_OBJECT":{"scuml_response":["41099","41107","41105","41102"]},"LINE":7},{"LINE_GENERAL":{"sub_header_number":"1.3.2"},"OTHER_OBJECT":{"scuml_response":["41110"]},"LINE":8},{"LINE_GENERAL":{"sub_header_number":"1.4.1"},"OTHER_OBJECT":{"scuml_response":["41117","41113","41116"]},"LINE":9},{"LINE_GENERAL":{"sub_header_number":"1.4.2"},"OTHER_OBJECT":{"scuml_response":["41121"]},"LINE":10},{"LINE_GENERAL":{"sub_header_number":"1.4.3"},"OTHER_OBJECT":{"scuml_response":["41122"]},"LINE":11},{"LINE_GENERAL":{"sub_header_number":"1.5.1"},"OTHER_OBJECT":{"scuml_response":["41135","41137","41201"]},"LINE":12},{"LINE_GENERAL":{"sub_header_number":"1.5.2"},"OTHER_OBJECT":{"scuml_response":["41138","41139"]},"LINE":13},{"LINE_GENERAL":{"sub_header_number":"1.6.1"},"OTHER_OBJECT":{"scuml_response":["41129"]},"LINE":14},{"LINE_GENERAL":{"sub_header_number":"1.6.2"},"OTHER_OBJECT":{"scuml_response":["41134"]},"LINE":15},{"LINE_GENERAL":{"sub_header_number":"2.1.1"},"OTHER_OBJECT":{"scuml_response":["41140"]},"LINE":16},{"LINE_GENERAL":{"sub_header_number":"2.2.1"},"OTHER_OBJECT":{"scuml_response":["41143"]},"LINE":17},{"LINE_GENERAL":{"sub_header_number":"2.2.2"},"OTHER_OBJECT":{"scuml_response":["41145"]},"LINE":18},{"LINE_GENERAL":{"sub_header_number":"2.2.3"},"OTHER_OBJECT":{"scuml_response":["41149"]},"LINE":19},{"LINE_GENERAL":{"sub_header_number":"2.2.4"},"OTHER_OBJECT":{"scuml_response":["41153"]},"LINE":20},{"LINE_GENERAL":{"sub_header_number":"2.2.5"},"OTHER_OBJECT":{"scuml_response":["41154"]},"LINE":21},{"LINE_GENERAL":{"sub_header_number":"2.2.6"},"OTHER_OBJECT":{"scuml_response":["41159"]},"LINE":22},{"LINE_GENERAL":{"sub_header_number":"2.2.7"},"OTHER_OBJECT":{"scuml_response":["41160"]},"LINE":23},{"LINE_GENERAL":{"sub_header_number":"2.3.1"},"OTHER_OBJECT":{"scuml_response":["41170"]},"LINE":24},{"LINE_GENERAL":{"sub_header_number":"2.3.2"},"OTHER_OBJECT":{"scuml_response":["41172"]},"LINE":25},{"LINE_GENERAL":{"sub_header_number":"2.3.3"},"OTHER_OBJECT":{"scuml_response":["41175"]},"LINE":26},{"LINE_GENERAL":{"sub_header_number":"2.4.1"},"OTHER_OBJECT":{"scuml_response":["41176"]},"LINE":27},{"LINE_GENERAL":{"sub_header_number":"2.5.1"},"OTHER_OBJECT":{"scuml_response":["41180"]},"LINE":28},{"LINE_GENERAL":{"sub_header_number":"2.5.2"},"OTHER_OBJECT":{"scuml_response":["41183"]},"LINE":29},{"LINE_GENERAL":{"sub_header_number":"2.6.1"},"OTHER_OBJECT":{"scuml_response":["41186"]},"LINE":30},{"LINE_GENERAL":{"sub_header_number":"2.6.2"},"OTHER_OBJECT":{"scuml_response":["41187"]},"LINE":31},{"LINE_GENERAL":{"sub_header_number":"2.6.3"},"OTHER_OBJECT":{"scuml_response":["41190"]},"LINE":32},{"LINE_GENERAL":{"sub_header_number":"2.6.4"},"OTHER_OBJECT":{"scuml_response":["41191"]},"LINE":33},{"LINE_GENERAL":{"sub_header_number":"2.7.1"},"OTHER_OBJECT":{"scuml_response":["41193"]},"LINE":34},{"LINE_GENERAL":{"sub_header_number":"2.7.2"},"OTHER_OBJECT":{"scuml_response":["41195"]},"LINE":35},{"LINE_GENERAL":{"sub_header_number":"2.8.1"},"OTHER_OBJECT":{"scuml_response":["41197"]},"LINE":36},{"LINE_GENERAL":{"sub_header_number":"2.8.2"},"OTHER_OBJECT":{"scuml_response":["41200"]},"LINE":37}]}]';
        const parsed = JSON.parse(jsonString);
        console.log("Valid JSON", parsed);
      } catch (e) {
        console.error("Invalid JSON", e);
      }

      appFetch
        .post(apiEndpoints.menuAction, {
          body: JSON.stringify(postData),
        })
        .then((result) => {
          console.log("wine =>=>", result);
          let { ERROR_MESSAGE: errMsg, ERROR_NUMBER: errNo } = result;

          MySwal.fire({
            text: errMsg,
            icon: errNo === 0 ? "success" : "error",
          });

          if (errNo !== 0) {
            throw new Error(errMsg);
          }

          // if(buttonAction === "UPDATE"){
          //     return;
          // }

          if (Object.keys(result.DOWNLOAD_LINK || []).length > 0) {
            let fileName = result.DOWNLOAD_LINK;
            let extension = (/\.[0-9a-z]+$/i.exec(fileName) ?? [])[0] ?? "";
            saveAs(fileName, "pms_file_10" + extension);
          }

          let page = { ...context.pageConfig };
          let [leftArea, MainArea, rightArea] = page.subcomponents;
          let mainApprovalArea = result?.layout.subcomponents[1];
          page.subcomponents = [leftArea, mainApprovalArea, rightArea];

          resolve(result);

          console.log("wine =>=>", result);
          updateMenu(result?.MENU_BADGE);
          typeof setGroupDrill === "function" && setGroupDrill(null);
          typeof setGroups === "function" &&
            setGroups(
              mainApprovalArea.subcomponents[0]?.subcomponents[0]?.options
            );

          //run this block if page is entered via menu link
          if (!setGroupDrill) {
            setContext((prev) => ({ ...prev, pageConfig: page }));
          }
        })
        .catch(() => resolve(false));
    });

  const updateBidOptions = ({ options, name, buttonItem, targetid }) => {
    console.log("updating bid options", options, name, buttonItem);
    if (/print/i.test(name)) {
      // setIsOpen(true);
      // setPreviewData(options);
      const printData = {
        ...options,
        target: buttonItem.action_type,
        targetid,
      };
      console.log("print data", printData);
      printAction(printData);
      return;
    }

    setBidModal(true);
    // setBidOptions(options);
    setBidOptions({ ...options, buttonItem: buttonItem });
  };

  const closeModal = () => setIsOpen(false);

  return (
    <>
      {bidModal && (
        <BidModal
          setIsOpen={setBidModal}
          isOpen={bidModal}
          bidOptions={bidOptions}
          setBidOptions={setBidOptions}
          actions={actions}
          getInitialValues={getInitialValues}
          getObjectValue={getObjectValue}
        />
      )}
      {commentModalOpen && (
        <CommentModal
          buttonData={buttonData}
          setIsOpen={setCommentModalOpen}
          isOpen={commentModalOpen}
          updateData={updateData}
        />
      )}

      {previewData && (
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={() => {}}
          open={isOpen}
        >
          <div className="min-h-screen h-full px-4 text-center">
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
            <span
              className="inline-block h-full align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block max-w-6xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-2xl">
              <div className="mt-4 flex justify-end gap-2">
                <PrintButton data={previewData} />
                <button
                  type="button"
                  className="pointer inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <PrintPreview data={previewData} menuId={menuId} />
            </div>
          </div>
        </Dialog>
      )}

      <div className="h-full pb-24 overflow-auto scrollbar scrollbar-thin scrollbar-w-1 scrollbar-thumb-gray-200 scrollbar-thumb-rounded-full bg-gray-100 p-3 pr-1 rounded-sm">
        {data &&
          data.map((item, idx) => (
            <LineGrid
              actions={actions}
              lines={data.length}
              hasMultiButton={hasMultiButton}
              updateBidOptions={updateBidOptions}
              key={idx}
              item={item}
            />
          ))}
        <div className="w-full h-32"></div>
      </div>
    </>
  );
}

const GridStyle = styled.div`
  background: #fbfbfb;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 7px;
`;

const ToggleGridButtonIcon = styled.div`
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.primary};
`;

function ActionDropdown({ buttons, handleDropdown }) {
  const theme = useTheme();
  const menuRef = React.useRef();
  const [menuPosition, setMenuPosition] = useState("bottom");

  useEffect(() => {
    if (menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      // If the menu would overflow, change position
      if (rect.bottom > viewportHeight) {
        setMenuPosition("top");
      } else {
        setMenuPosition("bottom");
      }
    }
  }, [menuRef]);

  return (
    <>
      {(buttons?.length ?? 0) > 0 && (
        <Menu as="div" className="relative inline-block text-left z-30">
          <div>
            <Menu.Button
              as={ButtonStyle}
              className="shadow-md bg-gray-100 p-2 px-3 rounded-md text-xs font-semibold inline-flex justify-center self-start items-center gap-2"
            >
              Actions
              <ToggleGridButtonIcon className="shadow w-4 h-4 rounded-full inline-grid place-items-center">
                <ChevronDownIcon
                  width={16}
                  height={16}
                  fill={theme?.colors?.primary}
                />
              </ToggleGridButtonIcon>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="px-1 py-1 ">
                {buttons?.map((button) => (
                  <Menu.Item onClick={() => handleDropdown(button)}>
                    {({ active }) => (
                      <button
                        className={`${
                          active ? "bg-primary text-white" : "text-gray-900"
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      >
                        {button.name}
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      )}
    </>
  );
}

const LineGrid = ({
  item,
  actions,
  updateBidOptions,
  lines,
  hasMultiButton,
}) => {
  let { targetid, summary, options, button } = item;
  const theme = useTheme();
  const [childOptions, setChildOptions] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [processing, setProcessing] = useState(false);

  let itemStatus = summary?.filter((item) => item.name === "Status");
  let customItems = summary?.filter((item) => item.name !== "Status");
  //override the button with active item to maintain single line
  console.log("the line grid item", item, summary, itemStatus);
  console.log("the line grid item status", itemStatus);
  button = activeItem?.button || button;

  const BadgeValue = (value) => {
    let color;
    if (value == "PENDING" || value == "Pending") {
      color = "bg-yellow-500";
    } else if (value == "APPROVED" || value == "Approved") {
      color = "bg-green-700";
    } else if (value == "Overdue" || value == "OVERDUE") {
      color = "bg-red-700 ";
    } else if (value == "OPEN" || value == "Open") {
      color = " bg-emerald-300  ";
    } else if (value == "CLOSED" || value == "Closed") {
      color = "bg-blue-600";
    } else if (value == "Active" || value == "ACTIVE") {
      color = "bg-blue-600";
    } else {
      color = "bg-gray-600 ";
    }
    // let style = `capitalize text-xs text-white block ${color} rounded-md p-1 my-1 text-center max-w-min truncate`;
    let style = `rounded-tr-lg rounded-bl-lg w-full justify-end relative -top-7 -right-7 max-w-min my-1 capitalize text-sm ${color} px-2 py-1 origin-center -translate-y-1 text-white truncate`;

    return (
      <span
        className={style}
        dangerouslySetInnerHTML={{ __html: value }}
      ></span>
    );
  };

  // useEffect(() => {
  //   setActiveItem(null);
  // }, [targetid]);

  // const getActiveItem = (item) => {
  //   let postData = {
  //     action: item.action,
  //     layoutId: item.layoutid,
  //     targetId: item.targetid,
  //     target: item.target
  //   };

  //   setProcessing(true);
  //   appFetch
  //     .get(appendQueryToUri(apiEndpoints.menuView, postData))
  //     .then((res) => {
  //       console.log("setting active item",res)
  //       var lineDetails = res?.options[0]?.line_details[0]
  //       var childOptions = res?.options[0]?.options
  //       setActiveItem(lineDetails);
  //       setChildOptions(childOptions)
  //     })
  //     .catch((e) => console.log(e.message))
  //     .finally(() => setProcessing(false));
  // };

  // const handleDropdown = (button) => {
  //   getActiveItem({...item,action:button.name})
  // }

  // let actionBtns = button?.filter(x => x.action == "action")
  // const nonActionBtns = button?.filter(x => x.action != "action")

  // if(actionBtns.length == 0){
  //   actionBtns = item?.button?.filter(x => x.action == "action")
  // }

  return (
    <GridStyle className="transaction-line p-7 mb-6 relative">
      <div className="flex justify-between relative">
        <div className="flex gap-4 flex-1">
          <div
            className="border px-3 rounded-lg grid place-items-center"
            style={{ backgroundColor: "#F3F3F3" }}
          >
            <span className="text-md font-bold inline-grid place-items-center">
              <span
                dangerouslySetInnerHTML={{ __html: customItems[0]?.value }}
              ></span>
            </span>
          </div>
          <div className="flex flex-col">
            {customItems.slice(1, -1).map(({ name, value }, idx) => {
              return (
                <div className="text-xs inline-flex md:text-sm" key={idx}>
                  <span dangerouslySetInnerHTML={{ __html: value }}></span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex items-start justify-between flex-col gap-2">
          {lines > 1 && hasMultiButton && (
            <div class="flex items-center place-self-end">
              <input
                id={`check-control-${item.targetid}`}
                type="checkbox"
                value=""
                class="w-4 h-4 text-primary bg-gray-100 border-gray-300 rounded focus:ring-primary  focus:ring-2"
              />
              <label
                htmlFor={`check-control-${item.targetid}`}
                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                {""}
              </label>
            </div>
          )}

          {itemStatus.length >= 1 && BadgeValue(itemStatus[0].value)}

          <div
            style={{ borderColor: "#D0D0D0" }}
            className="-mr-7 border-r-0 px-4 py-1 rounded-l-3xl border text-semibold text-xs md:text-sm"
            dangerouslySetInnerHTML={{ __html: customItems.slice(-1)[0].value }}
          />
        </div>
      </div>

      <div className="h-7"></div>

      {activeItem && (
        <div className="block min-w-full w-full">
          <EditableTableRow
            {...item}
            item={activeItem}
            getInitialValues={getInitialValues}
            getObjectValue={getObjectValue}
            actions={actions}
            collapseSection={() => setActiveItem(null)}
            setActiveItem={setActiveItem}
            setChildOptions={setChildOptions}
            action={activeItem?.action}
          />
        </div>
      )}

      {!activeItem && (
        <ButtonActions
          {...{
            ...item,
            item: { ...activeItem },
            headerControl: item?.parent ?? item?.edit_header ?? [],
            editable_controls: activeItem?.line_control_edit,
            lines: activeItem?.line_data,
            setActiveItem,
            setChildOptions,
            actions,
            action: activeItem?.action,
          }}
        />
      )}
      {/* 
      <div className={classNames("flex gap-2 mt-3 mb-1 lg:flex-row flex-col justify-between")}>
        {processing && 
              <ButtonStyle className="shadow-md bg-gray-100 p-2 px-3 rounded-md text-xs font-semibold inline-flex justify-center self-start">
                <span className="mr-2 text-xs font-medium text-black">
                  Loading
                </span>{" "}
                <Spinner width={16} height={16} fill="#aaaaaa" />
              </ButtonStyle>
          }
        {!processing && <ActionDropdown buttons={actionBtns} handleDropdown={handleDropdown}/>}
        <div className="flex gap-2">
        {nonActionBtns?.map((obj, idx) => 
        <TransactionLineButton
          key={idx}
          {...obj}
          {...{
            targetid,
            actions,
            item:{...activeItem},
            headerControl: (item?.parent ?? item?.edit_header ?? []),
            editable_controls: activeItem?.line_control_edit,
            lines: activeItem?.line_data
          }}
        />)}
        </div>
      </div> */}

      {childOptions && (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm text-gray-500 dark:text-gray-400">
            <tbody>
              {childOptions?.map((option, index) => (
                <InnerLineGrid
                  key={index}
                  targetid={option.targetid}
                  updateBidOptions={updateBidOptions}
                  lineOption={option?.line_details[0]}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </GridStyle>
  );
};

const ButtonActions = (props) => {
  console.log("buttonActions props", props);
  const [processing, setProcessing] = useState(false);
  const { button, item, setActiveItem, setChildOptions, ...others } = props;

  var buttons = item?.button ?? button;

  let actionBtns = buttons?.filter((x) => x.action == "action");
  const nonActionBtns = buttons?.filter((x) => x.action != "action");

  if (actionBtns.length == 0) {
    actionBtns = button?.filter((x) => x.action == "action");
  }

  console.log("nonActionBtns props", nonActionBtns);

  const handleDropdown = (button) => {
    const postData = {
      layoutid: props.layoutid,
      target: props.target,
      targetid: props.targetid,
      action: button.name,
    };
    getActiveItem(postData);
  };

  const getActiveItem = (postData) => {
    setProcessing(true);
    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, postData))
      .then((res) => {
        console.log("response from server", res);
        var lineDetails = res?.options[0]?.line_details[0];
        var childOptions = res?.options[0]?.options;
        const activeItemData = { ...lineDetails, action: postData.action };
        setActiveItem(activeItemData);
        setChildOptions(childOptions);
      })
      .catch((e) => console.log(e.message))
      .finally(() => {
        setProcessing(false);
      });
  };

  return (
    <div
      className={classNames(
        "flex gap-2 mt-3 mb-1 lg:flex-row flex-col justify-between z-50"
      )}
    >
      {processing && (
        <ButtonStyle className="shadow-md bg-gray-100 p-2 px-3 rounded-md text-xs font-semibold inline-flex justify-center self-start">
          <span className="mr-2 text-xs font-medium text-black">Loading</span>{" "}
          <Spinner width={16} height={16} fill="#aaaaaa" />
        </ButtonStyle>
      )}
      {!processing && (
        <ActionDropdown buttons={actionBtns} handleDropdown={handleDropdown} />
      )}
      <div className="flex gap-2">
        {nonActionBtns?.map((obj, idx) => (
          <TransactionLineButton key={idx} {...others} {...obj} item={item} />
        ))}
      </div>
    </div>
  );
};

const InnerLineGrid = (props) => {
  const [lineOption, setLineOption] = useState(null);
  const { updateBidOptions } = props;

  console.log("inner grid props", props);

  useEffect(() => {
    setLineOption(props.lineOption);
  }, []);

  return (
    <>
      <tr className="w-full bg-gray-100 sm:table-row hidden">
        {lineOption?.child_summary.map(({ value }) => (
          <td className="py-2 px-5">
            <span
              className="text-xs font-semibold"
              dangerouslySetInnerHTML={{ __html: value }}
            />
          </td>
        ))}
        <td className="py-2 px-5">
          <div className="flex gap-4">
            {lineOption?.button.map((item) => (
              <ButtonStyle2
                onClick={() =>
                  updateBidOptions({
                    options: lineOption,
                    name: item.name,
                    buttonItem: item,
                    targetid: props.targetid,
                  })
                }
                className="bg-transparent py-1 hover:bg-red-500 shadow text-xs font-semibold hover:text-white px-4 border border-red-500 hover:border-transparent rounded"
              >
                {item.name}
              </ButtonStyle2>
            ))}
          </div>
        </td>
      </tr>
      {/* Responsive View */}
      <tr className="sm:hidden block">
        <td colSpan={lineOption?.child_summary.length + 1} className="p-4">
          <div className="flex flex-wrap justify-between">
            {lineOption?.child_summary.map(({ value }) => (
              <div className="w-full sm:w-1/2 text-xs font-semibold mb-2">
                <span dangerouslySetInnerHTML={{ __html: value }} />
              </div>
            ))}
            <div className="w-full flex gap-4 mt-2">
              {lineOption?.button.map((item) => (
                <ButtonStyle2
                  onClick={() =>
                    updateBidOptions({
                      options: lineOption,
                      name: item.name,
                      buttonItem: item,
                      targetid: props.targetid,
                    })
                  }
                  className="bg-transparent py-1 hover:bg-red-500 shadow text-xs font-semibold hover:text-white px-4 border border-red-500 hover:border-transparent rounded"
                >
                  {item.name}
                </ButtonStyle2>
              ))}
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};

export default TransactionListLine;
